import React, { useState, useMemo } from "react";
import { useSelector } from "react-redux";
import { CardTitle } from "reactstrap";
import { TooltipComponent } from "../../../Component";
import { BarChart } from "../../charts/default/Charts";

const PatientGraph = () => {
  const graphs = useSelector((state) => state.graph.graphs);
  const [period, setPeriod] = useState(6);
  
const patientArray = Object.entries(graphs?.data?.enroll || {}).map(
  ([month, value]) => ({
    label: month,
    value: Number(value),
  })
);  

    // 👉 Filter enroll data based on period
  const filteredPatient = useMemo(() => {
    if (!graphs?.data?.enroll) return [];

   return patientArray.slice(-period);
  }, [graphs, period]);
console.log("E", graphs?.data?.enroll);
  // 👉 Calculate total sales
  const totalPatient = useMemo(() => {
    return filteredPatient.reduce((sum, item) => sum + Number(item.value || 0), 0);
  }, [filteredPatient]);
  return (
    <React.Fragment>
      <div className="card-title-group align-start mb-2">
        <CardTitle>
          <h6 className="title">Total New Enrollment</h6>
           <p>In last {period} months Enrollment data..</p>
				   <select
					className="form-select mt-2"
					style={{ width: "140px" }}
					value={period}
					onChange={(e) => setPeriod(Number(e.target.value))}
				  >
					<option value={1}>Last 1 Month</option>
					<option value={3}>Last 3 Months</option>
					<option value={6}>Last 6 Months</option>
					<option value={12}>Last 12 Months</option>
				  </select>
        </CardTitle>
        <div className="card-tools">
          <TooltipComponent
            icon="help-fill"
            iconClass="card-hint"
            direction="left"
            id="Tooltip-2"
            text="Total New Enrollment patients"
          />
        </div>
      </div>
      <div className="align-end flex-sm-wrap g-4 flex-md-nowrap">
        <div className="nk-sale-data">
		 <span className="amount">
             $
            {new Intl.NumberFormat("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(totalPatient)}
          </span>
         
          {/* <span className="sub-title">
            <span className="change up text-success">
              <Icon name="arrow-long-up" />
              1.93%
            </span>
            since last month
          </span> */}
        </div>
        <div className="nk-sales-ck h-fit">
          <BarChart data={graphs?.data?.enroll} label="Enrollment" />
        </div>
      </div>
    </React.Fragment>
  );
};
export default PatientGraph;
